// This file contains a Pixi manifest with bundles for all in-game assets.
import type { AssetsManifest } from "pixi.js";

import Dice_Default1_1 from "@/game/assets/dice/default/Dice_Player_1.png";
import Dice_Default1_2 from "@/game/assets/dice/default/Dice_Player_2.png";
import Dice_Default1_3 from "@/game/assets/dice/default/Dice_Player_3.png";
import Dice_Default1_4 from "@/game/assets/dice/default/Dice_Player_4.png";
import Dice_Default1_5 from "@/game/assets/dice/default/Dice_Player_5.png";
import Dice_Default1_6 from "@/game/assets/dice/default/Dice_Player_6.png";

import Dice_Default2_1 from "@/game/assets/dice/default/Dice_Opponent_1.png";
import Dice_Default2_2 from "@/game/assets/dice/default/Dice_Opponent_2.png";
import Dice_Default2_3 from "@/game/assets/dice/default/Dice_Opponent_3.png";
import Dice_Default2_4 from "@/game/assets/dice/default/Dice_Opponent_4.png";
import Dice_Default2_5 from "@/game/assets/dice/default/Dice_Opponent_5.png";
import Dice_Default2_6 from "@/game/assets/dice/default/Dice_Opponent_6.png";

export const DiceManifest: AssetsManifest = {
  bundles: [
    {
      name: "dice-default-local",
      assets: [
        {
          alias: "dice-local-1",
          src: Dice_Default1_1
        },
        {
          alias: "dice-local-2",
          src: Dice_Default1_2
        },
        {
          alias: "dice-local-3",
          src: Dice_Default1_3
        },
        {
          alias: "dice-local-4",
          src: Dice_Default1_4
        },
        {
          alias: "dice-local-5",
          src: Dice_Default1_5
        },
        {
          alias: "dice-local-6",
          src: Dice_Default1_6
        }
      ]
    },
    {
      name: "dice-default-opponent",
      assets: [
        {
          alias: "dice-opponent-1",
          src: Dice_Default2_1
        },
        {
          alias: "dice-opponent-2",
          src: Dice_Default2_2
        },
        {
          alias: "dice-opponent-3",
          src: Dice_Default2_3
        },
        {
          alias: "dice-opponent-4",
          src: Dice_Default2_4
        },
        {
          alias: "dice-opponent-5",
          src: Dice_Default2_5
        },
        {
          alias: "dice-opponent-6",
          src: Dice_Default2_6
        }
      ]
    }
  ]
};
